<template >
  <div class="mainbody">
    <!-- <h3 class="title">校友会活动</h3> -->
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">校友会照片</span>
      <el-button type="primary" size="small" style="float: right" @click="addImage()">新增</el-button>
    </div>
    <div class="tableInfo">
      <el-row :gutter="24" justify="center">
        <el-col :span="6" v-for="item in data_list" :key="item.id" :offset="0" style="margin-bottom: 23px">
          <el-card
            :body-style="{
              padding: '0px'
            }"
          >
            <el-image
              ref="elCardImg"
              fit="scale-down"
              :src="urlPath + item.link"
              v-bind:style="{
                width: '100%',
                height: '200px',
                display: 'block'
              }"
            >
              <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="footDiv">
              <p class="title1">{{ item.uploader }}</p>
              <p class="title2">{{ item.createTime }}</p>
            </div>
            <div style="float: right; padding-right: 24px">
              <el-button class="operateText" size="mini" type="text" @click="delImage(item)">删除</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
    <add-association-image-dialog ref="_addAssociationImageDialog" @toSave="saveSucc"></add-association-image-dialog>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import addAssociationImageDialog from '@/components/dialog/addAssociationImageDialog'

export default {
  components: { addAssociationImageDialog },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1
    }
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .associationImageList({
          token: localStorage.getItem('token'),
          association_id: this.$route.query.id,
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            info.uploader = info.uploader == null ? '***' : info.uploader
            info.createTime = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 删除图片
    delImage(item) {
      this.$confirm('是否删除此图片?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
        // type: "warning",
      })
        .then(() => {
          this.$api
            .delAssociationImage({
              token: localStorage.getItem('token'),
              association_id: this.$route.query.id,
              id: item.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    },
    // 新增图片
    addImage() {
      this.$nextTick(() => {
        this.$refs._addAssociationImageDialog.show(this.$route.query.id)
      })
    },
    // 新增成功
    saveSucc() {
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.footDiv {
  padding: 16px 24px 0px 24px;
}
.footDiv .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: #595959;
}
.footDiv .title2 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12.48px;
  line-height: 21px;
  color: #8c8c8c;
}
</style>


// WEBPACK FOOTER //
// src/components/association/associationImages.vue